module.exports = __webpack_public_path__ + "static/media/logoBlue.949369fc.svg";